const countFractionDigits = (value) => { // value must be String
	let temp = value.split('.')
	if (temp.length > 1) {
		return temp[1].length
	} else {
		return 0
	}
}

const removeSymbol = (value, currency = 'usd') => {
	/*
		Intl.NumberFormat use small non-breaking space (\u202f) for thousand
		separator and normal non-breaking space beforece currency (\xa0).

		https://stackoverflow.com/questions/54242039/intl-numberformat-space-character-does-not-match#:~:text=NumberFormat%20use%20small%20non%2Dbreaking%20space%20(%5Cu202f)%20for%20thousand%20separator%20and%20normal%20non%2Dbreaking%20space%20beforece%20currency%20(%5Cxa0)
	*/


	if (currency === 'usd') {
		return value.split("$")[1].replace('$', '')
	}
	else if (currency === 'idr') {
		const returnValue = value.replace('Rp', '').replace("\xa0", '')
		return returnValue
	}
}

const currencyFormat = (value, currency = 'usd', showCurrency = false) => { // value must be String
	value = String(value)
	const minimumFractionDigits = countFractionDigits(value)

	let currencyOption = currency.toUpperCase()
	let localeArgument = 'en-US'

	const options = {
		style: 'currency',
		currency: currencyOption ,
		minimumFractionDigits: minimumFractionDigits,
	}

	const numberFormat = new Intl.NumberFormat(localeArgument, options)


	let formatted = numberFormat.format(value)

	// Remove the currency symbol
	let returnValue = formatted.replace(/[^\d.,\- ]+/g, "").trim()

	// remove symbol if showCurrency is false
	// if (!showCurrency) {
	// 	formatted = removeSymbol(numberFormat.format(value), currency)
	// 	returnValue = `${value < 0 ? '-' : ''}` + formatted
	// }

	return returnValue
}


export default {
	currencyFormat
}